import { isLeafLinkNoLongerOpenStatus } from '../is-leaflink-no-longer-open-status.js';
import { leafLinkRungFor } from './leaflink-rung-for.js';
import { leafLinkWorkflowStatusKeyForId } from './leaflink-workflow-status-key-for-id.js';
import { salesOrderEndedLikeLeafLink } from './sales-order-ended-like-leaflink.js';
/** How the stored LeafLink status relates to the LeafLink status the Nudool status maps to (settled decisions on the Move Back mapping, the Submitted note, forward-only catch-up and cancel-or-reject). */
export function leafLinkStatusAlignment(options) {
    const { salesOrderStatusId, leafLinkStatus } = options;
    const status = leafLinkWorkflowStatusKeyForId(salesOrderStatusId);
    if (status === null)
        return 'not-tracked';
    if (salesOrderEndedLikeLeafLink(salesOrderStatusId, leafLinkStatus) ||
        leafLinkRungFor(status) === leafLinkStatus) {
        return 'in-step';
    }
    if ((status === 'SUBMITTED' || status === 'AWAITING_APPROVAL') && leafLinkStatus === 'Accepted') {
        return 'cannot-follow-back';
    }
    if (isLeafLinkNoLongerOpenStatus(leafLinkStatus))
        return 'ended-on-leaflink';
    return 'differs';
}
//# sourceMappingURL=leaflink-status-alignment.js.map